import * as React from 'react';
import { MAX_COLUMN_WIDTH } from 'src/services/links/measureTextWidth';

interface ITableCellProps {
  width: number;
  className?: string;
}

export const TableCell: React.FunctionComponent<ITableCellProps> = ({
  width,
  children,
  className = '',
}) => (
  <div
    className={`p-2 border-r border-grey-light group relative ${className}`}
    style={{ width: `${width}em` }}
  >
    <span className="block w-full whitespace-nowrap text-overflow-ellipsis overflow-hidden">
      {children}
    </span>
    {width === MAX_COLUMN_WIDTH && (
      <span className="p-2 bg-grey-light shadow-lg absolute z-50 pin-t pin-l pin-r break-all hidden group-hover:block">
        {children}
      </span>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/views/Links/components/TableCell.tsx